export function handleFileDownload(blob: Blob, fileName: string, mimeType: string) {
    const url = window.URL.createObjectURL(new Blob([blob], { type: mimeType }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName || "download");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

